export enum VIDEO_PROVIDER_CODE {
	WISTIA = 1
}

export const WISTIA_THUMBNAIL_FALLBACK = 'siteassets/global/logos/build-w-ferguson';

export const PLAY_BUTTON = 'siteassets/global/overlays/play_overlay';
